export default {
    CREATE_AUTOMATION: () => '/mappingBoardGmailUser/createMappingBoardGmailUser',
    GET_ALL_AUTOMATION: () => '/mappingBoardGmailUser/getAllMappingBoardGmailUser',
    DELETE_AUTOMATION: (id) => `/mappingBoardGmailUser/deleteMappingBoardGmailUser/${id}`,
    UPDATE_AUTOMATION: (id) => `/mappingBoardGmailUser/updateMappingBoardGmailUser/${id}`,
    GET_AUTOMATION_ID: (id) => `/mappingBoardGmailUser/getMappingBoardGmailUserBy/${id}`,
};
